<ion-item lines="none">
  <ng-content select="[slot='start']"></ng-content>
  <ng-container *ngIf="mode === 'edit'; else newComment">
    <div class="d-flex flex-col flex-1 flex--center gap-2 w-100">
      <bl-richtext-editor
        [placeholder]="'COMMON.LABELS.WRITE_COMMENT' | translate"
        [(ngModel)]="value"
        [disabled]="submitting"
        [editMode]="true"
        [mentionsEnabled]="true"
        [maxHeight]="'350px'"
        (enterPressed)="onEnter()"
        class="w-100"
      ></bl-richtext-editor>
      <div class="d-flex flex-1x ml-auto flex--center gap-2">
        <ion-button
          class="cancel-btn"
          (click)="cancelEditing.emit()"
          shape="round"
          fill="outline"
        >
          {{ "COMMON.LABELS.CANCEL" | translate }}
        </ion-button>
        <ion-button
          (click)="submit()"
          [disabled]="disabledSubmit"
          shape="round"
        >
          {{ "COMMON.LABELS.SAVE" | translate }}
        </ion-button>
      </div>
    </div>
  </ng-container>
  <ng-template #newComment>
    <div class="d-flex flex-1 flex--center gap-2">
      <bl-richtext-editor
        [placeholder]="'COMMON.LABELS.WRITE_COMMENT' | translate"
        [(ngModel)]="value"
        [disabled]="submitting"
        [mentionsEnabled]="true"
        [maxHeight]="'350px'"
        (enterPressed)="onEnter()"
        class="flex-1"
      ></bl-richtext-editor>
      <ion-button
        class="submit-new-comment-btn"
        (click)="submit()"
        [disabled]="disabledSubmit || submitting"
        shape="round"
        fill="solid"
        [attr.aria-label]="'COMMON.LABELS.POST' | translate"
        [title]="'COMMON.LABELS.POST' | translate"
      >
        <ion-spinner
          *ngIf="submitting; else submitIcon"
          name="crescent"
        ></ion-spinner>
        <ng-template #submitIcon>
          <svg-icon
            slot="icon-only"
            key="chat-send"
            size="xl"
          ></svg-icon>
        </ng-template>
      </ion-button>
    </div>
  </ng-template>
</ion-item>
